/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface KioskSessionStatusDto
 */
export interface KioskSessionStatusDto {

    /**
     * @type {number}
     * @memberof KioskSessionStatusDto
     */
    memberId: number;

    /**
     * @type {number}
     * @memberof KioskSessionStatusDto
     */
    sessionEventId: number;

    /**
     * Last session state snapshot sent by Unity. Null until the first metrics POST.
     *
     * @type {{ [key: string]: any; }}
     * @memberof KioskSessionStatusDto
     * @example {"exerciseSequence":2,"lap":1,"phase":"work","payload":{"lastReps":8,"lastWeight":20}}
     */
    metadata: { [key: string]: any; } | null;

    /**
     * @type {string}
     * @memberof KioskSessionStatusDto
     */
    startedAt: string;

    /**
     * @type {string}
     * @memberof KioskSessionStatusDto
     */
    updatedAt: string;
}
